import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "./context/AuthContext";

import LoginPage from "./pages/LoginPage";
import ReportsPage from "./pages/ReportsPage";
import AdminUsers from "./pages/AdminUsers";
import AdminCompanies from "./pages/AdminCompanies";
import AdminReports from "./pages/AdminReports";
import AdminAuthorizedReports from "./pages/AdminAuthorizedReports";
import AdminDepartments from "./pages/AdminDepartments";
import LandingPage from "./pages/LandingPage";
import Dashboard from "./components/Dashboard";


import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

export default function App() {
  const { user } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const handleToggleCollapse = () => setCollapsed((prev) => !prev);

  // 👇 Layout component defined inline
  const Layout = () => (
    <div className="flex min-h-screen bg-gray-100">
      {user && <Sidebar collapsed={collapsed} onToggleCollapse={handleToggleCollapse} />}
      <div
        className={`flex flex-col flex-grow transition-all duration-300 ${
          user ? (collapsed ? "ml-[72px]" : "ml-[288px]") : ""
        }`}
      >
        {user && <Navbar />}
        <main className="p-0 flex-grow overflow-visible">
          <Outlet />
        </main>
        {user && <Footer />}
      </div>
    </div>
  );

  return (
    <Router>
      <Routes>
        {/* Public Routes (no layout) */}
        <Route path="/reports/:department" element={<ReportsPage fallbackToFirstReport />} />
        <Route path="/" element={user ? <Navigate to="/reports/Accounting/1" /> : <LandingPage />} />
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />


        {/* Protected Routes (wrapped in layout) */}
        {user && (
          <Route element={<Layout />}>
            <Route path="/reports/:department/:report" element={<ReportsPage />} />

            {user.role === "admin" && (
              <>
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/companies" element={<AdminCompanies />} />
                <Route path="/admin/reports" element={<AdminReports />} />
                <Route path="/admin/authorized-reports" element={<AdminAuthorizedReports />} />
                <Route path="/admin/departments" element={<AdminDepartments />} />
              </>
            )}
          </Route>
        )}

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}
